import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';
import { IRootState } from './types';
import { reducers } from './reducers';

const initialState: IRootState = {
  selectedCommissionsPlan: {
    type: 'Fixed',
    name: '',
    description: '',
    fixedType: 0,
    fixedAmount: '',
    productCommissions: [] as Array<IRootState['selectedProduct']>,
    commissionSteps: [
      {
        index: 0,
        from: 1,
        amount: '',
      },
    ],
    bonuses: [
      {
        index: 0,
        name: '',
        from: '',
        fixedType: 'flat',
        fixedAmount: '',
      },
    ],
    bonusBase: 'Personal',
  } as IRootState['selectedCommissionsPlan'],
  commissionPlans: [],
  tab: '1',
  activeStep: 0,
  toggleDeleteDialog: false,
  isOpenAssignMembersNav: false,
  memberEmails: [],
  commissionMode: 'create',
  commissionsSummary: [],
  commissionView: 0,
  tableCommissionView: 0,
  isOpenTeamCommissionsNav: false,
  selectedTeam: {} as IRootState['selectedTeam'],
  commissionTeams: [],
  commissionTeamsSummary: [],
  isOpenDeleteTeamDialog: false,
  selectedProduct: {} as IRootState['selectedProduct'],
};

export const slice = createSlice({
  name: STORE_SLICES.COMMISSIONS,
  initialState,
  reducers,
});

const commissionsActions = slice.actions;

const commissionsPersistConfig = {
  key: PERSIST_KEYS.COMMISSIONS,
  storage,
  whitelist: [
    'selectedCommissionsPlan',
    'activeStep',
    'commissionPlans',
    'commissionMode',
    'commissionsSummary',
    'commissionView',
    'tableCommissionView',
    'commissionTeams',
    'isOpenTeamCommissionsNav',
  ],
};

export {
  commissionsActions,
};

export default persistReducer(commissionsPersistConfig, slice.reducer);
